import React, { useState, useContext, useEffect } from 'react';

import { texts, properties } from './AporteMejoraDocumentacionData';
import AppContext from 'AppContext';
import { useHistory } from "react-router-dom";
import { tipoFirma, properties as appProperties } from 'AppData';
import useApp from 'AppFunctions';
import RestProvider from 'providers/RestProvider';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';
import { properties as propertiesCloudConfig } from 'config/Config';
import useOperations from 'components/commons/subirArchivo/SubirArchivoFunction';
import {properties as propertiesAporteDoc} from '../aporteDocumentacion/AporteDocumentacionData';


const useFunctions = () => {

    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);

    ///Hooks gestion msg errores
    let idAlert = 0;
    const [message, setMessage] = useState({ msg: '', severity: '' });
    const addAlert = msg => setAlerts([...alerts, { id: idAlert++, msg }]);
    const [alerts, setAlerts] = useState([]);
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }
    const dispatch = useDispatch();
    const { getMimeType, getMaxFileSize,getTipoSubido } = useOperations();

    /**
    * @function obtenerProcedenciaConvocatoria Obtiene la procedencia de una convocatoria (PCT2 o PCT3)
    */
    const obtenerProcedenciaConvocatoria = () => {
        return (procedimientoActual.fromPct3 !== undefined && procedimientoActual.fromPct3 === true) ? 'PCT3' : 'PCT2';
    }

    let procedenciaConvocatoria = obtenerProcedenciaConvocatoria();

    //Hooks
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [documentosVoluntarios, setDocumentosVoluntarios] = useState([]);
    const [tamMaximoSobrepasado, setTamMaximoSobrepasado] = useState(false);
    const [numInput, setNumInput] = useState(0);
    const [documentos,setDocumentos] = useState([]);
    const [mostrarMensaje, setMostrarMensaje] = useState(false);
    const [mostrarError, setMostrarError] = useState(false);
    const [textoError, setTextoError] = useState("");
    const [disabledBotonFirmar, setDisabledBotonFirmar] = useState(true);
    const [documentosEntrega, setDocumentosEntrega] = useState([]);
    const [mostrarConfirmacionFirma, setMostrarConfirmacionFirma] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessingFirma, setIsProcessingFirma] = useState(false);
    const [mostrarPopUpDesOk, setMostrarPopUpDesOk] = useState(false);
    const [msgErrorPresentacion, setMsgErrorPresentacion] = useState();
    const [mostrarErrorPresentacion, setMostrarErrorPresentacion] = useState(false);
    const [values, setValues] = useState("");
    const TAM_MAX_ANEXO = propertiesCloudConfig['TAM_MAX_MEJ_DOCUMENTACION'];
    const context = useContext(AppContext);
    const history = useHistory();
    const { firmaGenericaMasiva, calcularHashBase64, calcularDataSource, firmarGenerico, obtenerTipoFirma } = useApp();
    const { crudOperation, crudOperationsType } = RestProvider();

    let arrayVoluntariosTmp;

    useEffect(() => {
        arrayVoluntariosTmp = documentosVoluntarios;
    }, [documentosVoluntarios]);

    /**
     * Obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
    const obtenerTituloPagina = () => {
        context.updateTitlePage(texts.PAGE_TITLE);
    }

    /**
     * Volver a la bandeja de entrada
     */
    const volverABandeja = () => {
        history.push(properties.URL_BANDEJA)
    }

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    /**
     * @function handleOnDrop Gestion de la subida de documentos
     * @param {*} files Fichero subido por el usuario
     * @param {*} rejectedFiles Fichero rechazado subido por el usuario
     */
     const handleOnDrop = (files, rejectedFiles) => {
        const archivo = files[0].file ? files[0].file : files[0];
        var tamFicheroSubido = parseFloat((archivo.size / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES));

        if(TAM_MAX_ANEXO < tamFicheroSubido){
            setTamMaximoSobrepasado(true);
        } else {
            const fileName = archivo.name.toLowerCase();
            const extensionFormato = fileName.substring(fileName.lastIndexOf('.') + 1);
            let documentoV = {
                fichero: files[0],
                anexo: null,
                descripcionVoluntario: documentosVoluntarios[numInput].value,
                firmado: false,
                nombreFichero: {...archivo},
                idSolicitud: null, // <---Por definir
                idConvocatoria: null, // <---Por definir
                idProcedimiento: null, // <---Por definir
                extensionFormato: extensionFormato,
                tamnyoFichero: tamFicheroSubido * 1000, //<---- Hay que pasarlo en kbytes para guardar el tamaño en el mismo formato que los demás
            };

            // Guardar base64 solo para PDF
            if (extensionFormato === 'pdf') {
               documentosVoluntarios[numInput].pdf = files[0].data;
               documentoV.fichero.data = files[0].data.split('base64,')[1];
            } else {
               // Para imágenes y videos se usa FormData en guardarArchivoMultimedia
               guardarArchivoMultimedia(documentoV);
            }
            documentos.push(documentoV);
            tratamienoAnexoVoluntario(archivo.size);
        }
     }

     /**
     * @function tratamienoAnexoVoluntario Metodo que crea un nuevo registro en el array voluntarios
     * @param {*} pesoDoc tamaño del documento subido
     */
    const tratamienoAnexoVoluntario = (pesoDoc) => {

        documentosVoluntarios[numInput].mostrarDocAnexo = true;
        documentosVoluntarios[numInput].tamDoc = (pesoDoc / properties.UN_MEGABYTE_EN_BYTE).toFixed(properties.NUMERO_DECIMALES);

        const arrayTemp = [...documentosVoluntarios];

        setNumInput(numInput + 1);
        const cantidadPDF = documentos.filter(doc => doc.extensionFormato === 'pdf').length;
        if(cantidadPDF > 0){
            setDisabledBotonFirmar(false);
        }
        let documentoVoluntario = {
            id: Date.now(),
            mostrarDropZone: false,
            value: "",
            mostrarDocAnexo: false,
            tamDoc: "",
            pdf: "",
            img: properties.PATH_IMG_PDF
        }
        arrayTemp.push(documentoVoluntario);
        setDocumentosVoluntarios(arrayTemp);

    };

   /**
    * Guarda un archivo multimedia (imagen o video) como documento voluntario.
    *
    * Esta función construye el DTO necesario para registrar un documento multimedia en el backend,
    * determinando su tipo (imagen o video) a partir del MIME del archivo subido. Luego realiza una
    * operación `POST` para guardar el archivo en el recurso de archivos multimedia.
    *
    * En caso de éxito:
    * - Agrega el documento subido a la lista de documentos con su `idPCT` asignado por el backend.
    * - Muestra un mensaje de éxito al usuario.
    *
    * En caso de error:
    * - Muestra un mensaje de error apropiado.
    * - Elimina el archivo fallido mediante la función `eliminarArchivoFallido`.
    *
    * @async
    * @function guardarArchivoMultimedia
    * @param {Object} documento - Objeto que contiene el archivo a guardar y sus metadatos.
    */
   const guardarArchivoMultimedia = async (documento) => {
     // Normalizamos el acceso al File
     const archivo = documento?.fichero?.file ? documento.fichero.file : documento.fichero;
     const filePath = archivo?.path;

     if (!filePath) {
       handleSetMessage("El archivo no es válido.", "error");
       return;
     }

     const tipoDocumento = await recuperarTipoDocVol(properties.CODIGO_MEJ_MULTI);
     const idExpediente = solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id;
     const idFaseAndIdEstado = await obtenerIdFaseIdEstado(idExpediente);

     setIsLoading(true);

     try {
       const DocumentoDto = {
         nombre: filePath,
         descripcion: documento.descripcionVoluntario,
         estadoElaboracion: "EE_01",
         fechaAries: null,
         idEstado: idFaseAndIdEstado.idEstado,
         idFase: idFaseAndIdEstado.idFase,
         idExpediente: idExpediente,
         nivelAcceso: "Libre",
         numeroRegistroEntrada: null,
         tipoCreador: "ciudadano",
         idConfAnexo: null,
         datoExpedienteDto: {
           organismo: {
             dir3: "A01025913",
           },
         },
         organismoDto: null,
         tipoDocumento: {
           id: tipoDocumento.id,
           nombre: tipoDocumento.nombre,
           codigo: tipoDocumento.codigo,
           descripcion: tipoDocumento.descripcion,
           origen: tipoDocumento.origen,
           tiposFormato: tipoDocumento.tiposFormato
             ? tipoDocumento.tiposFormato
             : documento.extensionFormato,
           tipoDocumentoEni: null,
           firmable: false,
           firmableSello: false,
           registrable: false,
           firmaServidor: false,
           aliasCertificado: tipoDocumento.aliasCertificado,
         },
       };

       const formData = new FormData();
       formData.append(
         "documentoDto",
         new Blob([JSON.stringify(DocumentoDto)], { type: "application/json" })
       );
       formData.append("fichero", archivo);

       const response = await crudOperation(
         crudOperationsType.CUSTOM,
         propertiesAporteDoc.RESOURCE_ARCHIVO_MULTIMEDIA,
         {
           method: propertiesAporteDoc.CRUD_TYPE_POST,
           data: formData,
           headers: { "Content-Type": "multipart/form-data" },
         }
       );

       setDocumentos((prevDocs) =>
         prevDocs.map((doc) =>
           doc.descripcionVoluntario === documento.descripcionVoluntario
             ? { ...doc, idPCT: response.data.id }
             : doc
         )
       );
       handleSetMessage(
         "El archivo: " + filePath + " se presentó correctamente.",
         "success"
       );
     } catch (error) {
       if (error.response?.data?.detailedError) {
         setTextoError(error.response.data.detailedError);
       } else {
         setTextoError("Error inesperado al presentar el archivo.");
       }
       setMostrarError(true);
       eliminarArchivoFallido(documento);
     } finally {
       setIsLoading(false);
     }
   };

   /**
    * Elimina un archivo fallido del array de documentos voluntarios.
    *
    * Esta función busca un documento fallido por su `descripcionVoluntario` en el array `documentosVoluntarios`.
    * Si lo encuentra, lo elimina del array y agrega un objeto vacío para mantener la estructura.
    * También actualiza el índice `numInput` y desactiva el botón de firmar si sólo queda un campo.
    * Además, elimina el mismo documento del array `documentos` si existe allí.
    *
    * @function eliminarArchivoFallido
    * @param {Object} documento - Objeto que representa el documento fallido a eliminar.
    */
   const eliminarArchivoFallido = (documento) => {
           const arrayTemp = [...documentosVoluntarios];
           for( var i = 0; i < arrayTemp.length; i++){
               if(documento.descripcionVoluntario === arrayTemp[i].value) {
                   arrayTemp.splice(i, 1);
                   let documentoVoluntario = {
                       id: Date.now(),
                       mostrarDropZone: false,
                       value: "",
                       mostrarDocAnexo: false,
                       tamDoc: "",
                       pdf: "",
                       img: properties.PATH_IMG_PDF
                   }
                   arrayTemp.push(documentoVoluntario);
                   setDocumentosVoluntarios(arrayTemp);
                   setNumInput(arrayTemp.length-1);
                   break;
               }
           }
          const cantidadPDF = documentos.filter(doc => doc.extensionFormato === 'pdf').length;
          if (cantidadPDF === 0) {
              setDisabledBotonFirmar(true);
          }

           for( var j = 0; j < documentos.length; j++){
               if(documento.descripcionVoluntario === documentos[j].descripcionVoluntario) {
                   documentos.splice(j, 1);
               }
           }
   };

   /**
    * @function recuperarTipoDocVol
    */
   const recuperarTipoDocVol = async (codigo) => {
       let tipoDocVol;
       await crudOperation(
               crudOperationsType.CUSTOM,
               propertiesAporteDoc.RESOURCE_TIPO_DOC,
               {
                   url: propertiesAporteDoc.RESOURCE_TIPO_DOC_CODIGO + codigo,
                   method: 'GET'
               }
       ).then(response => {
           tipoDocVol = response.data;
       }).catch(() => {
           setTextoError("Ha ocurrido un error en recuperar el tipo de documento.");
           setMostrarError(true);
       });
       return tipoDocVol;
   };

    /**
     * @function handleChange Gestion de la subida de documentos
     * @param {*} e Fichero subido por el usuario
     */
    const handleChange = (e) => {
        setValues(e.target.value);
        documentosVoluntarios[numInput].value = e.target.value;

        if (e.target.value === null || e.target.value === undefined || e.target.value === "") {
            documentosVoluntarios[numInput].mostrarDropZone = false;
        } else {

            if (numInput !== 0) {
                for (var j = 0; j < documentosVoluntarios.length - 1; j++) {
                    if (documentosVoluntarios[j].value === e.target.value) {
                        const arrayTemp = [...documentosVoluntarios];
                        arrayTemp[numInput].mostrarDropZone = false;
                        setDocumentosVoluntarios(arrayTemp);
                        break;
                    } else {
                        documentosVoluntarios[numInput].mostrarDropZone = true;
                    }
                }
            } else {
                documentosVoluntarios[numInput].mostrarDropZone = true;
            }
        }
    };

    /**
     * @function eliminarAnexoVoluntario Metodo que controla el INPUT del componente SubidaArchivoVoluntario para mostrar el Dropzone
     * @param {*} e Fichero subido por el usuario
     */
    const eliminarAnexoVoluntario = (e) => {
        const indexDocumento = documentos.findIndex(
                (doc) => doc.descripcionVoluntario === e.target.name
        );
        if(documentos[indexDocumento].extensionFormato !=='pdf'){
            borrarDocumentoPorIdentificador(e.target.name);
        }else{
            const arrayTemp = [...documentosVoluntarios];

            for( var i = 0; i < arrayTemp.length; i++){
                if(e.target.name === arrayTemp[i].value) {
                    arrayTemp.splice(i, 1);
                    setDocumentosVoluntarios(arrayTemp);
                    setNumInput(numInput - 1);
                }
            }
           const cantidadPDF = documentos.filter(doc => doc.extensionFormato === 'pdf').length;
           if (cantidadPDF ===0) {
                setDisabledBotonFirmar(true);
           }

        for( var j = 0; j < documentos.length; j++){ 
            if(e.target.name === documentos[j].descripcionVoluntario) {
                documentos.splice(j, 1);
            }
        }
     }
    };

    /**
     * Elimina de la colección de documentos aquel que coincida con el identificador
     * y actualiza todos los campos relacionados con su eliminación.
     *
     * @function borrarDocumentoPorIdentificador
     * @param {*} identificador - Valor de `descripcionVoluntario` del documento a eliminar
     */
    const borrarDocumentoPorIdentificador = async (identificador) => {
      const indexDocumento = documentos.findIndex(
        (doc) => doc.descripcionVoluntario === identificador
      );

      if (indexDocumento !== -1) {
        setIsLoading(true);
        try {
          await crudOperation(
            crudOperationsType.CUSTOM,
            propertiesAporteDoc.RESOURCE_ANEXO_PCT,
            {
              url: propertiesAporteDoc.RESOURCE_ELIMINAR_ANEXO_PCT + documentos[indexDocumento].idPCT,
              method: propertiesAporteDoc.CRUD_TYPE_GET
            }
          );

          const nuevosDocumentos = [...documentos];
          nuevosDocumentos.splice(indexDocumento, 1);
          setDocumentos(nuevosDocumentos);
          handleSetMessage("El archivo se ha eliminado correctamente",'success');
        } catch (error) {
          setTextoError("Error al eliminar el documento:"+ error);
          setMostrarError(true);
        } finally {
          setIsLoading(false);
        }
      }

      // Eliminar también de documentosVoluntarios
      const indexVoluntario = documentosVoluntarios.findIndex(
        (doc) => doc.value === identificador
      );

      if (indexVoluntario !== -1) {
        const nuevosVoluntarios = [...documentosVoluntarios];
        nuevosVoluntarios.splice(indexVoluntario, 1);
        setDocumentosVoluntarios(nuevosVoluntarios);
        setNumInput(nuevosVoluntarios.length - 1);
      }
    };

    /**
     * @function cerrarError
     */
    const cerrarError = () => {
        setMostrarError(false);
    };

    /**
     * @function mostrarConfirmarError Metodo que hace saltar el componente mostrar cuando un anexo subido es rechazado
     * @param {*} rejectedFile Fichero rechazado
     * @param {*} tamMaxDoc tamaño maximo permitido para el documento
     */
    const mostrarConfirmarErrorFichero = (rejectedFile, tamMaxDoc) => {
        let tipoArchivoRechazado = 'pdf'; // Valor por defecto
        let tamMaxFicheroMB = tamMaxDoc;

        if (rejectedFile && rejectedFile.length > 0) {
            const file = rejectedFile[0].file ? rejectedFile[0].file : rejectedFile[0];
            const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            const maxSize = getMaxFileSize(ext, tamMaxDoc);
            const mime = file.type.toLowerCase();

            if (mime.includes("video")) {
                tipoArchivoRechazado = "video";
                tamMaxFicheroMB = maxSize / (1024 * 1024);
            } else if (mime.includes("image")) {
                tipoArchivoRechazado = "foto";
                tamMaxFicheroMB = maxSize / (1024 * 1024);
            } else if (mime.includes("pdf")) {
                tipoArchivoRechazado = "pdf";
            } else {
                tipoArchivoRechazado = "no-valido";
            }
        }

        setTextoError(getMensajeDropRejected(tamMaxFicheroMB, tipoArchivoRechazado));
        setMostrarError(true);
    };

    const getMensajeDropRejected = (tamMaxDoc, tipoArchivoRechazado) => {
        switch (tipoArchivoRechazado) {
            case 'pdf':
                return texts.TEXTO_ERROR_DROP_REJECTED1 + tamMaxDoc + texts.TEXTO_ERROR_DROP_REJECTED2;
            case 'video':
                return texts.TEXTO_ERROR_DROP_REJECTED3 + propertiesAporteDoc.ALLOWEDVIDEOFORMATS + texts.TEXTO_ERROR_DROP_REJECTED5 + tamMaxDoc + texts.TEXTO_ERROR_DROP_REJECTED6;
            case 'foto':
                return texts.TEXTO_ERROR_DROP_REJECTED4 + propertiesAporteDoc.ALLOWEDIMAGEFORMATS + texts.TEXTO_ERROR_DROP_REJECTED5 + tamMaxDoc + texts.TEXTO_ERROR_DROP_REJECTED6;
            case 'no-valido':
                return texts.TEXTO_ERROR_DROP_REJECTED7 + propertiesAporteDoc.ALLOWEDVIDEOFORMATS + "," + propertiesAporteDoc.ALLOWEDIMAGEFORMATS + texts.TEXTO_ERROR_DROP_REJECTED5 + tamMaxDoc + texts.TEXTO_ERROR_DROP_REJECTED6;
            default:
                return texts.TEXTO_ERROR_DROP_REJECTED1 + tamMaxDoc + texts.TEXTO_ERROR_DROP_REJECTED2;
        }
    };

    const cerrarConfirmacionFirma = () => {
        setMostrarConfirmacionFirma(false);
    };

    const abrirConfirmacionFirma = () => {
        setMostrarConfirmacionFirma(true);
    };

    const firmarKo = (type, message) => {
        setTextoError(message);
        setMostrarError(true);
    }

    const navegarBandeja = () => {
        history.push("/BandejaSolicitudes");
    }

    /**
     * Firmar documentos aportados
     */
    const firmar = () => {
        cerrarConfirmacionFirma(false);
        let documentosAfirmar = [];
        let doc = null;

        if (procedenciaConvocatoria === 'PCT2') {
            doc = documentos;
        } else {
            for (const documento of documentos) {
                if (documento.fichero.data !== undefined && documento.fichero.file?.type === 'application/pdf') {
                    documentosAfirmar.push(documento.fichero.data);
                }
            }
            doc = documentosAfirmar;
        }
        if (obtenerTipoFirma(infoUsuario, convocatoriaSeleccionada) === tipoFirma.FIRMA_SMS) {
            firmarOk(null);
        } else {
            firmaGenericaMasiva(doc, firmarOk, firmarKo, procedenciaConvocatoria);
        }
    }

    /**
     * 
     * @param {*} firma 
     * @param {*} index 
     */
    const montarDocumentosEntrega = (signatureBase64, certificate864) => {
        let firmas = signatureBase64.split(':');
        setDocumentosEntrega([]);

        for (let i = 0; i < documentos.length; i++) {
            let documentoEntrega = {
                firmaBase64: firmas[i],
                hashDocumentoBase64: calcularHashBase64(documentos[i]),
                documento: documentos[i].fichero.data,
                nombreDocumento: documentos[i].descripcionVoluntario,
                tipoDocumento: properties.TIPO_DOC_MEJORA,
                descripcionDocumento: documentos[i].descripcionVoluntario
            }
            documentosEntrega.push(documentoEntrega);
        }
    }

    const montarDocumentosEntregaPCT3 = (signatureBase64) => {
        let firmas = signatureBase64 !== null ? signatureBase64.split(':') : null;
        setDocumentosEntrega([]);
        
        for(let i=0; i<documentos.length; i++){
            if(documentos[i].extensionFormato === 'pdf')
            {
                let documentoEntrega = {
                    firmaBase64: firmas === null ? null : firmas[i],
                    hashDocumentoBase64: calcularHashBase64(documentos[i]),
                    documento: documentos[i].fichero.data,
                    nombreDocumento: documentos[i].descripcionVoluntario,
                    tipoDocumento: properties.TIPO_DOC_MEJORA,
                    descripcionDocumento: documentos[i].descripcionVoluntario,
                    firmado:true
                }
                documentosEntrega.push(documentoEntrega);
            }
        } 
          
        return  documentosEntrega;
    }

    /**
     * 
     * @param {*} firma 
     * @param {*} index 
     */
    const firmarOk = (signatureBase64, certificate864, index) => {
        procedenciaConvocatoria === 'PCT2' ? firmarOkPCT2(signatureBase64, certificate864, index) : firmarOkPCT3(signatureBase64, certificate864);
    }

    const firmarOkPCT2 = (signatureBase64, certificate864, index) => {
        montarDocumentosEntrega(signatureBase64, index)
        let inputPresentarSolicitud = montarInputMejoraDocumentacion();
        setIsLoading(true);
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PRESENTAR_SOLICITUD, { url: properties.URL_PRESENTAR_SOLICITUD, method: 'post', data: inputPresentarSolicitud }).then(response => {
            setIsLoading(false);
            setMostrarMensaje(true);
        }).catch(function (error) {
            setIsLoading(false);
            if (error.response) {
                let msg = error.response.data.messageDescription;
                setTextoError(msg + texts.PARTE_2_MSG_ERROR);
            } else {
                setTextoError(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR);
            }
            setMostrarError(true);
        })
    }

    //PRESENTAR MEJORA DOCUMENTACION PCT3
    const firmarOkPCT3 = async (signatureBase64, certificate864, index) => {
        let inputPresentarMejoraDocPct3 = await montarInputMejoraDocumentacionPct3(signatureBase64);
        setIsLoading(true);
        setIsProcessingFirma(true);
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PRESENTAR_MEJORA_DOC_PCT3, { url: '', method: 'post', data: inputPresentarMejoraDocPct3 }).then(response => {
            dispatch(insertNewState({ filnedName: 'recibi', value: response.data.recibi }));
            dispatch(insertNewState({ filnedName: 'numRegistroAries', value: response.data.numRegistroAries }));
            dispatch(insertNewState({ filnedName: 'numeroExpediente', value: response.data.numeroExpediente }));
            dispatch(insertNewState({ filnedName: 'idExpediente', value: response.data.idExpediente }));
            setIsLoading(false);
            setMostrarMensaje(true);
        }).catch(function (error) {
            setIsLoading(false);
            if (error.response.status == 504) {
                let msg = error.response.statusText;
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            } else if (error.response) {
                let msg = error.response.data.messageDescription;
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            } else {
                setMsgErrorPresentacion(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR);
            }
            setMostrarErrorPresentacion(true);
        })
    }

    /**
     * 
     * @returns 
     */
    const montarInputMejoraDocumentacion = () => {

        let inputPresentarSolicitud = {
            dataSource: calcularDataSource(procedimientoActual.codigoAplicacion),
            dniLogin: infoUsuario.interesadoNif,
            numeroSerieCertificadoLogin: infoUsuario.datosCertificado ? infoUsuario.datosCertificado.numeroSerie : null,
            isloginCertificadoDigital: infoUsuario.tipoAutenticacion === appProperties.TIPO_AUTENTICACION_CERTIFICADO ? true : false,
            listadoDocumentosEntregaDTO: documentosEntrega,
            organismo: "A01004509", //TODO
            idProcedimiento: procedimientoActual.id,
            cdProcTrewa: convocatoriaSeleccionada.cdProcTrewa,
            descripcionProcedimiento: procedimientoActual.descripcion,
            descripcionConvocatoria: convocatoriaSeleccionada.descripcion,
            codigoSistemaTrewa: procedimientoActual.cdSistemaTrewa,
            usuarioTrewa: perfilSeleccionado.cdUsuarioTrewa,
            tipoExpedienteTrewa: convocatoriaSeleccionada.cdTipoExpTrewa,
            enumProcesoEntrega: properties.PROCESO_ENTREGA_APORTE,
            idMoaddSolicitudesPDF: solicitudActual.idSolicitud,
            idAplicacion: procedimientoActual.codigoAplicacion,
            idExpTrewa: solicitudActual.idExpediente,
            orden: convocatoriaSeleccionada.idOrden,
            nombrePerfilFirma: perfilSeleccionado.cdNombreTrewa,
            idConvocatoria: convocatoriaSeleccionada.id
        }

        return inputPresentarSolicitud;
    }

    const montarInputMejoraDocumentacionPct3 = (firma) => {
        let enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_MEJORA_DOC;

        let inputPresentarMejoraDoc = {
            enumProcesoEntrega: enumeradoProcesoEntrega,
            idExpediente: solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id,
            numeroExpediente: solicitudActual.numeroExpediente,
            idConvocatoria: convocatoriaSeleccionada.id,
            dniLogin: infoUsuario.interesadoNif,
            numeroSerieCertificadoLogin: infoUsuario.datosCertificado ? infoUsuario.datosCertificado.numeroSerie : null,
            isloginCertificadoDigital: infoUsuario.tipoAutenticacion === appProperties.TIPO_AUTENTICACION_CERTIFICADO ? true : false,
            descripcionConvocatoria: convocatoriaSeleccionada.descripcion,
            fechaInicioPresentacion: new Date(convocatoriaSeleccionada.fechaInicioPresentacion),
            fechaFinPresentacion: new Date(convocatoriaSeleccionada.fechaFinPresentacion),
            idProcedimiento: procedimientoActual.id,
            descripcionProcedimiento: procedimientoActual.descripcion,
            usuarioAries: convocatoriaSeleccionada.codAriesUsuario,
            passwordAries: convocatoriaSeleccionada.codAriesPassword,
            asuntoAries: convocatoriaSeleccionada.codAriesAsunto,
            destinatarioAries: convocatoriaSeleccionada.codAriesDestinatario,
            listDocumentos: montarDocumentosEntregaPCT3(firma), //TODO
            perfil: perfilSeleccionado,
            enumTipoFirma: obtenerTipoFirma()
        }

        return inputPresentarMejoraDoc;
    }

    /**
     * @function obtenerIdFaseIdEstado Función que obtiene el id de fase y el id del estado a través del idExpediente
     * @param {*} idExpediente
     * @returns
     */
    const obtenerIdFaseIdEstado = async (idExpediente) => {
        let expediente = null, fase = null, estado = null, res = null;

        // Paso 1. Obtención del expediente
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATO_EXPEDIENTE, { url: `/ov3/${idExpediente}`, method: 'get' }).then(response => {
            expediente = response.data;
            // Paso 2. Obtención del idFase y del idEstado actual del expediente
            let idFase = expediente.objetosTramitables[0].idFaseActual;
            let idEstado = expediente.objetosTramitables[0].idEstadoFaseActual;
            res = {
                idFase: idFase,
                idEstado: idEstado
            };
        }).catch(function (error) {
            setMsgErrorPresentacion('Se ha producido un error al obtener el expediente');
        });
        return res;
    }

    return {
        obtenerTituloPagina, volverABandeja, updateFormat, isPhoneVersion, documentosVoluntarios, setDocumentosVoluntarios, tamMaximoSobrepasado, handleOnDrop, handleChange,
        eliminarAnexoVoluntario, mostrarConfirmarErrorFichero, mostrarMensaje, textoError, mostrarError, disabledBotonFirmar, firmar, mostrarConfirmacionFirma,
        cerrarConfirmacionFirma, abrirConfirmacionFirma, isLoading, navegarBandeja, cerrarError, isProcessingFirma, mostrarPopUpDesOk, msgErrorPresentacion, mostrarErrorPresentacion,
        setMostrarErrorPresentacion, alerts, message, setMessage
    };

}
export default useFunctions;